/**
 * Троттлинг «последнее значение побеждает» (KAN-982).
 *
 * Для потоков, где каждое сообщение — полный снимок состояния: промежуточные
 * снимки не нужны, нужен свежий. Первое значение отдаётся сразу (на следующем
 * тике), дальше — не чаще раза в `ms`, и всегда последнее пришедшее. Значение,
 * пришедшее в окне, не теряется: оно уйдёт в конце окна.
 *
 * `cancel()` — при отписке: отложенная доставка после неё не случится.
 */
export function latestThrottle<T>(deliver: (value: T) => void, ms: number) {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let pending: { value: T } | null = null;
  let lastDeliveredAt = Number.NEGATIVE_INFINITY;

  const flush = () => {
    timer = null;
    if (!pending) return;
    const { value } = pending;
    pending = null;
    lastDeliveredAt = Date.now();
    deliver(value);
  };

  return {
    push(value: T) {
      pending = { value };
      if (timer) return;
      timer = setTimeout(flush, Math.max(0, lastDeliveredAt + ms - Date.now()));
    },
    cancel() {
      if (timer) clearTimeout(timer);
      timer = null;
      pending = null;
    },
  };
}
